import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  height: auto;
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 500px;
`;

export const StepTitle = styled.div`
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 500;
`;

export const ProductGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 25px;
  overflow-y: auto;
  padding: 4px;
  flex: 1;
  align-content: start;

  @media (max-width: 991px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  @media (max-width: 575px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const getColumnColors = (columnIndex) => {
  const colors = [
    { color: '#9810FA', background: '#9810FA1A' },
    { color: '#2D6CDF', background: '#2D6CDF1A' },
    { color: '#15C7A7', background: '#15C7A71A' },
    { color: '#FDC700', background: '#F4D2801A' },
    { color: '#FF6A00', background: '#FF6A001A' },
  ];
  return colors[columnIndex % 5];
};

export const ProductCard = styled.div`
  border-radius: 16px;
  background: ${({ $columnIndex }) => getColumnColors($columnIndex).background};
  border: 1px solid transparent;
  border-top: 1.01px solid #ffffffcc;
  box-shadow:
    0px 4.04px 6.05px -4.04px #0000001a,
    0px 10.09px 15.13px -3.03px #0000001a;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 19px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  min-height: 180px;

  ${({ $selected }) =>
    $selected &&
    `
    border: 1.5px solid #3b82f6;
    background: #ffffff;
    box-shadow: 0px 0px 12px rgba(59, 130, 246, 0.3);
    transform: translateY(-2px);
  `}

  &:hover {
    background: #ffffff;
    transform: translateY(-2px);
  }
`;

export const ProductImage = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow:
    0px 4.04px 6.05px -4.04px #0000001a,
    0px 10.09px 15.13px -3.03px #0000001a;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const ProductName = styled.p`
  font-weight: 700;
  font-size: 14.12px;
  line-height: 20.18px;
  letter-spacing: 0px;
  text-align: center;
  color: ${({ $columnIndex }) => getColumnColors($columnIndex).color};
  margin: 16px 0 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  max-width: 100%;
  min-height: 40px;
`;

export const ProductService = styled.p`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  text-align: center;
  color: ${({ $columnIndex }) => getColumnColors($columnIndex).color};
  margin: 8px 0 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-word;
  max-width: 100%;
`;

export const OfferGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  overflow-y: auto;
  padding: 4px;
  flex: 1;
  align-content: start;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const OfferCard = styled.div`
  background: linear-gradient(107.35deg, #296bcd 0%, #245499 43.88%);
  border-radius: 5px;
  padding: 4px 8px 4px;
  color: white;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  box-shadow: 0px 9.25px 18.5px -4.44px #00000040;
  transition: transform 0.2s cubic-bezier(0.2, 0, 0.2, 1);
  z-index: 1;
  transform: scale(1);
  backface-visibility: hidden;
  will-change: transform;
  -webkit-font-smoothing: antialiased;
  transform: translateZ(0);
  transform-origin: center center;
  filter: blur(0);
  min-height: 180px;
  -webkit-filter: blur(0);

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #00d3f3 0%, #2b7fff 100%);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 4px;
    width: 100%;
    background: white;
    pointer-events: none;
  }

  &:hover {
    transform: scale(1.02) translateZ(0);
    filter: brightness(1.02);
    z-index: 10;
  }

  ${(props) =>
    props.isActive &&
    `
    transform: scale(1.02);
    z-index: 5;
  `}
`;

export const BadgeIcon = styled.img`
  position: absolute;
  top: 5px;
  left: 1px;
  z-index: 2;
  width: 15px;
`;

export const CardHeader = styled.h3`
  font-weight: 900;
  font-size: 18px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #ffffff;
  margin-top: 32px;
  margin-bottom: 19px;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  max-width: 100%;
`;

export const PriceBox = styled.div`
  position: relative;
  border-radius: 6.58px;
  padding: 7.77px;
  text-align: left;
  margin-bottom: 8px;
  border: 1px solid #ffffff33;
  overflow: hidden;
  outline: none;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.1);
    z-index: 0;
    border: none;
  }

  * {
    position: relative;
    z-index: 1;
  }
`;

export const PriceTitle = styled.p`
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: #53eafd;
  margin-bottom: 3px;
  letter-spacing: 0.11px;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;
`;

export const PriceValue = styled.div`
  font-size: 26px;
  font-weight: 900;
  line-height: 26px;
  display: flex;
  color: #ffffff;
  letter-spacing: 0;
  backface-visibility: hidden;
  perspective: 1000px;
  font-variant-numeric: tabular-nums;
  align-items: baseline;
  display: inline-flex;
  transform: translateZ(0) scale(1);
  will-change: contents;

  span {
    font-size: 12px;
    margin-left: 2.96px;
    color: #53eafd;
    font-weight: 700;
    display: inline-block;
  }
`;

export const UnitsInfo = styled.p`
  font-size: 13px;
  margin-top: 3px;
  padding-top: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  color: #ffffff;
  font-weight: 600;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;
`;

export const ValidityBox = styled.div`
  font-size: 11px;
  font-weight: 400;
  display: flex;
  align-items: center;
  gap: 2px;
  color: #ffffff99;
  margin-top: 8px;
  font-weight: 500;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;

  span {
    color: #ffffff;
    font-weight: 600;
  }

  .calendar-icon {
    width: 12px;
  }
`;

export const FooterText = styled.p`
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 3px;
  color: #ffffff66;
  font-weight: 400;
  margin-top: 38px;
  margin-bottom: 4px;
  backface-visibility: hidden;
  transform: translateZ(0);
  perspective: 1000px;
`;

export const StarImg = styled.img`
  width: 11px;
  margin-right: 2px;
`;

export const DateImg = styled.img``;

export const LevinImg = styled.img`
  width: 14px;
`;

export const OfferImageWrapper = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 2;
  width: 30px;
  height: 30px;
  border-radius: 6px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OfferCardContent = styled.div`
  padding: 20px 16px;
  color: white;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 12px;
  margin-top: auto;
  padding-top: 20px;
  width: 100%;
  flex-shrink: 0;
`;

const BaseButton = styled.button`
  flex: 1;
  height: 44px;
  border-radius: 8px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const CancelButton = styled(BaseButton)`
  background: #ffffff;
  color: #0a0a0a;
  border: 1px solid #0000001a;

  &:hover:not(:disabled) {
    background: #f8f9fa;
  }
`;

export const BackButton = styled(BaseButton)`
  background: #ffffff;
  color: #0a0a0a;
  border: 1px solid #0000001a;

  &:hover:not(:disabled) {
    background: #f8f9fa;
  }
`;

export const NextButton = styled(BaseButton)`
  background: linear-gradient(90deg, #2a75e8 0%, #1f406e 100%);
  color: #ffffff;

  .rotate {
    transform: rotate(180deg);
  }

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

export const SubmitButton = styled(BaseButton)`
  background: linear-gradient(90deg, #2a75e8 0%, #1f406e 100%);
  color: #ffffff;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

export const LoadingMessage = styled.div`
  padding: 40px;
  text-align: center;
  color: #666;
  font-size: 16px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const EmptyMessage = styled.div`
  padding: 40px;
  text-align: center;
  color: #999;
  font-size: 16px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorMessage = styled.div`
  color: #dc3545;
  font-size: 14px;
  margin-top: 12px;
  padding: 8px 12px;
  background: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 6px;
`;
